import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Set up Google autocomplete in the search modals
placesAutoComplete.initializeCityState(
  ".js-wm-profile-search-form-city-state",
  null,
  pageData.get("currentCountry")
);
